"use client";
import React from "react";
import { Box, Text } from "@dxp-feed/ui";
import { IListStores } from "@/utils/redux/storeLocator/index";

interface IHeaderDropdown {
  selectedStore: IListStores | null;
  loading: boolean;
  storeStatus: string;
  geolocationError: string | null;
}

const HeaderDropdown: React.FC<IHeaderDropdown> = ({
  selectedStore,
  loading,
  storeStatus,
  geolocationError,
}) => {
  return (
    <Box className="cursor-pointer">
      <Text
        as="span"
        className="absolute -left-8 lg:-left-[27px] -top-1 icon-map text-[22px] text-brandBlack lg:text-brandWhite rounded"
      />
      <span
        tabIndex={0}
        role="button"
        className="font-bold text-body underline text-brandBlack lg:text-brandWhite line-clamp-1 text-ellipsis overflow-hidden max-w-[220px] rounded"
        aria-label={selectedStore?.locationName}
      >
        {selectedStore?.locationName}
      </span>
      <span
        role="status"
        className="4xs:!text-sm !text-[11px] whitespace-nowrap relative text-brandBlack lg:text-brandWhite rounded flex h-auto"
        aria-label={storeStatus}
        tabIndex={0}
      >
        {loading ? (
          <div className="text-brandWhite" data-testid="loading-spinner">
            Loading ...
          </div>
        ) : (
          <>
            {!selectedStore ? (
              <Text className="text-white-200 text-sm">
                No stores found in your area
              </Text>
            ) : (
              <>
                {storeStatus}
                {geolocationError && (
                  <div className="text-white-300">{geolocationError}</div>
                )}
                <Text
                  as="span"
                  className={
                    "px-2 icon-arrow text-[5.5px] inline-block origin-center w-7"
                  }
                />
              </>
            )}
          </>
        )}
      </span>
    </Box>
  );
};

export default HeaderDropdown;
